<template>
  <v-row no-gutters>
    <v-dialog
      v-model="$store.getters['Dashboard/showErrorModal']"
      persistent
      max-width="600"
      width="800"
    >
      <v-card style="color: white; border-radius: 2rem; background: #070f2f">
        <v-col
          class="text-center d-flex flex-column align-start  pl-16"
          md="12"
          sm="12"
        >
          <v-icon
            style="font-size: 180px; color:#aa4460; border: 3px solid white; border-radius: 50%"
            class="mt-16 mb-8"
            >mdi-close</v-icon
          >

          <h1
            class="text-center mb-12 font-weight-light"
            style="font-size: 40px; font-weight: 900; color: #aa4460"
          >
            Failed!
          </h1>

          <span
            style="color: white; font-size: 20px; text-align: left"
            class="mb-8"
          >
            {{ $store.getters["Dashboard/modalDescription"] }}
          </span>
          <span style="font-size: 20px">
            {{ $store.getters["Dashboard/modalText"] }}
          </span>
          <br />
          <v-btn
            rounded
            @click="handleRetry"
            class="mt-8 mb-8"
            x-large
            style="color: #fed400; border: 1px solid white !important; background: #070f2f"
            >Retry</v-btn
          >
        </v-col>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "ErrorModal",

  methods: {
    handleRetry() {
      this.$store.dispatch("Dashboard/hideErrorModal");
    }
  }
};
</script>
<style lang="scss"></style>
